module.exports = function getResource(label, vars = []) {
    const resources = {
        autoReplenishTitle: `Réapprovisionnement automatique (${vars[0]})`,
        changeMethod: 'Changer la méthode',
        free: 'GRATUIT',
        sameDayDelivery: 'Same-Day Delivery'
    };

    return resources[label];
};
